// AUTH
export const LOGIN = 'LOGIN'
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const LOGOUT = 'LOGOUT'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'

// FARMS
export const SELECT_FARM = 'SELECT_FARM'
export const CLEAR_FARM_SELECTION = 'CLEAR_FARM_SELECTION'
export const SET_FARM_LIST = 'SET_FARM_LIST'
export const SET_FILTERED_FARM_LIST = 'FILTERED_FARM_LIST'
export const FARM_LOADING = 'FARM_LOADING'
export const FARM_LOADED = 'FARM_LOADED'
export const FARM_CREATED = 'FARM_CREATED'
export const FARM_UPDATED = 'FARM_UPDATED'

// PROCESSORS
export const SET_PROCESSOR = 'SET_PROCESSOR'
export const SET_PROCESSORS = 'SET_PROCESSORS'

// PACKAGHING PLANT
export const SET_PACKAGING_PLANT = 'SET_PACKAGING_PLANT'

// BATCHES
export const SELECT_BATCH = 'SELECT_BATCH'
export const CLEAR_BATCH_SELECTION = 'CLEAR_BATCH_SELECTION'
export const SET_BATCH_LIST = 'SET_BATCH_LIST'
export const SET_FILTERED_BATCH_LIST = 'SET_FILTERED_BATCH_LIST'
export const BATCH_LOADING = 'BATCH_LOADING'
export const BATCH_LOADED = 'BATCH_LOADED'
export const BATCH_CREATED = 'BATCH_CREATED'
export const LOT_ADDED_TO_BATCH = 'LOT_ADDED_TO_BATCH'

// CERTTIFICATES
export const SET_CERTIFICATES_LIST = 'SET_CERTIFICATES_LIST'
export const CERTIFICATE_CREATED = 'CERTIFICATE_CREATED'
export const CERTIFICATE_UPDATED = 'CERTIFICATE_UPDATED'

// INGREDIENTS
export const SET_INGREDIENT_LIST = 'SET_INGREDIENT_LIST'

// SHIPMENTS
export const SELECT_SHIPMENT = 'SELECT_SHIPMENT'
export const CLEAR_SHIPMENT_SELECTION = 'CLEAR_SHIPMENT_SELECTION'
export const SET_SHIPMENT_LIST = 'SET_SHIPMENT_LIST'
export const SET_FILTERED_SHIPMENT_LIST = 'SET_FILTERED_SHIPMENT_LIST'
export const SHIPMENT_LOADING = 'SHIPMENT_LOADING'
export const SHIPMENT_LOADED = 'SHIPMENT_LOADED'
export const SHIPMENT_CREATED = 'SHIPMENT_CREATED'
export const SHIPMENT_UPDATED = 'SHIPMENT_UPDATED'

// LOTS
export const SELECT_LOT = 'SELECT_LOT'
export const CLEAR_LOT_SELECTION = 'CLEAR_LOT_SELECTION'
export const SET_LOT_LIST = 'SET_LOT_LIST'
export const SET_FILTERED_LOT_LIST = 'SET_FILTERED_LOT_LIST'
export const LOT_LOADING = 'LOT_LOADING'
export const LOT_LOADED = 'LOT_LOADED'
export const LOT_CREATED = 'LOT_CREATED'
export const LOT_UPDATED = 'LOT_UPDATED'

// SNACKBAR
export const SHOW_SNACK_BAR = 'SHOW_SNACK_BAR'
export const DISSMISS_SNACK_BAR = 'DISSMISS_SNACK_BAR'
